import React, { useRef, useState } from "react";
import api, { imgUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Upload, ImagePlus, X } from "lucide-react";
import { toast } from "sonner";

// value = storage url string; onChange(url)
const ImageUpload = ({ value, onChange, label = "Upload image", testid = "image-upload", aspect = "aspect-video" }) => {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("Please select an image"); return; }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(res.data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally { setUploading(false); }
  };

  return (
    <div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid={`${testid}-input`} />
      {value ? (
        <div className={`relative ${aspect} w-full rounded-xl overflow-hidden border border-border bg-secondary`}>
          <img src={imgUrl(value)} alt="preview" className="h-full w-full object-cover" />
          <div className="absolute top-2 right-2 flex gap-2">
            <Button type="button" size="sm" variant="secondary" onClick={() => inputRef.current?.click()} disabled={uploading}>
              {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
            </Button>
            <Button type="button" size="sm" variant="secondary" onClick={() => onChange("")}>
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      ) : (
        <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading}
          data-testid={`${testid}-button`}
          className={`${aspect} w-full rounded-xl border-2 border-dashed border-border bg-secondary/40 hover:bg-secondary transition-colors grid place-items-center text-muted-foreground`}>
          {uploading ? (
            <span className="flex items-center gap-2 text-sm"><Loader2 className="h-5 w-5 animate-spin" /> Uploading…</span>
          ) : (
            <span className="flex flex-col items-center gap-1 text-sm"><ImagePlus className="h-6 w-6" /> {label}</span>
          )}
        </button>
      )}
    </div>
  );
};

export default ImageUpload;
